// AgendaEditorPlugin.js
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { FaEdit, FaCheck, FaTimes } from 'react-icons/fa';

export const useAgendaEditor = (initialAgenda) => {
  const { t } = useTranslation();
  const [isEditing, setIsEditing] = useState(false);
  const [editedAgenda, setEditedAgenda] = useState(initialAgenda);
  const [isLoading, setIsLoading] = useState(false);

  const startEditing = () => {
    setIsEditing(true);
  };

  const cancelEditing = () => {
    setEditedAgenda(initialAgenda);
    setIsEditing(false);
  };

  return {
    isEditing,
    editedAgenda,
    isLoading,
    setEditedAgenda,
    startEditing,
    cancelEditing,
    setIsLoading,
  };
};

export const AgendaEditorControls = ({
  isEditing,
  isLoading,
  onStartEdit,
  onSave,
  onCancel
}) => {
  const { t } = useTranslation();
  if (!isEditing) {
    return (
      <button
        onClick={onStartEdit}
        className="text-blue-500 hover:text-blue-700 flex items-center space-x-1"
      >
        <FaEdit size={14} />
        <span>
          {/* Edit */}
          {t('Edit')}
        </span>
      </button>
    );
  }

  return (
    <div className="flex space-x-2">
      <button
        onClick={onSave}
        disabled={isLoading}
        className="flex items-center space-x-1 bg-blue-500 text-white px-3 py-1 rounded hover:bg-blue-600 disabled:opacity-50"
      >
        <FaCheck size={14} />
        <span>{isLoading ? "Saving..." : "Save"}</span>
      </button>
      <button
        onClick={onCancel}
        disabled={isLoading}
        className="flex items-center space-x-1 bg-gray-500 text-white px-3 py-1 rounded hover:bg-gray-600 disabled:opacity-50"
      >
        <FaTimes size={14} />
        <span>
          {t('Cancel')}
        </span>
      </button>
    </div>
  );
};

export const AgendaEditorContent = ({
  isEditing,
  editedAgenda,
  onAgendaChange,
  isLoading,
  defaultText = "No agenda set"
}) => {
  const { t } = useTranslation();
  return isEditing ? (
    <textarea
      value={editedAgenda}
      onChange={(e) => onAgendaChange(e.target.value)}
      className="w-full p-2 border rounded-md min-h-[100px]"
      disabled={isLoading}
    />
  ) : (
    <p className="text-[22] font-medium text-black mt-2">
      {/* {editedAgenda || defaultText} */}
      {editedAgenda || t('No agenda set')}
    </p>
  );
};